<template>
  <v-skeleton-loader :loading="loading" type="date-picker">
    <EditPoint v-bind="dataProp" />
  </v-skeleton-loader>
</template>

<script>
import { PointsHelpers } from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'
import store from '@/store'
import EditPoint from './EditPoint.vue'

export default {
  components: {
    EditPoint
  },
  data() {
    return {
      loading: true,
      pointData: '',
      id: null,
      name: '',
      sessionHandled: false
    }
  },
  computed: {
    ...mapGetters('auth', ['session']),
    dataProp() {
      const data = this.pointData
      return { pointData: data }
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    try {
      const response = this.pointData
      if (!response.hasOwnProperty('error')) {
        this.pointData = response
      } else {
        const snackbar = {
          text: this.$t(
            'fleet_management.points_of_interest.points_of_interest_detail.error.loading_point_data'
          ),
          color: 'error'
        }
        store.dispatch('ui/setSnackbar', snackbar)
      }
    } catch (error) {
      const errorText = PointsHelpers.getErrorMessageByCode(error.error)
      const snackbar = {
        text: errorText,
        color: 'error'
      }
      store.dispatch('ui/setSnackbar', snackbar)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
